import { Box, styled } from '@mui/material'
import { Icon } from '../eid-icons'
import { FC } from 'react'

const ValidationMessageRoot = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    margin: '1.2rem 0.8rem',
}))

const ErrorMessage = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    margin: '0 1rem',
    fontSize: '1.3rem',
    color: '#000000',
    lineHeight: 1.33,
}))

export const ValidationMessage: FC<{ message: string }> = (props) => {
    return (
        <ValidationMessageRoot role="alert">
            <Icon name="ErrorStatus" color="#d0021b" aria-hidden="true" />
            <ErrorMessage>{props.message}</ErrorMessage>
        </ValidationMessageRoot>
    )
}
